import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import AdminMenu from "../../AdminMenu";
import {
  addFranchiseStoreMap,
  getFranchiseAvailableStore,
  getFranchiseStoreOrderRevenue,
  updateFranchiseStoreMap,
} from "../../../services/FranchiseModal/Franchise";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";
import FinanceAdminMenu from "../../FinanceAdminMenu";

const FranchiseStoreMap = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item, franchise, storeMap } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const [brandStoreList, setBrandStoreList] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);

  const [storeData, setStoreData] = useState("");
  const [storeStatus, setStoreStatus] = useState(false);
  const [statusError, setStatusError] = useState("");
  const [franchiseOrderRevenueData, setFranchiseOrderRevenueData] = useState(
    []
  );

    const minimumDate = new Date();
    minimumDate.setMonth(minimumDate.getMonth() - 3);

    const maximumDate = new Date();
    maximumDate.setMonth(maximumDate.getMonth() + 3);


   let initialRevenueCalculateOnDate = new Date();
    const [revenueCalculateOnDate, setRevenueCalculateOnDate] = useState(
      new Date(initialRevenueCalculateOnDate)
    );
  

    
  const handleRevenueCalculateOnDateChange = (selectedDate) => {
    if (selectedDate !== undefined) {
      const currentTime = new Date();
      selectedDate.setHours(
        currentTime.getHours(),
        currentTime.getMinutes(),
        currentTime.getSeconds(),
        currentTime.getMilliseconds()
      );

      setRevenueCalculateOnDate(selectedDate);
    }
  };

  const fetchAllBrands = () => {
    getFranchiseAvailableStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const getBrandStore = Res.map((item, index) => ({
            name: item.storeName,
            value: item.id,
          }));
          setBrandStoreList(getBrandStore);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchStoreOrderRevenue = (data) => {
    getFranchiseStoreOrderRevenue(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
         const totalOrder = Res[0]?.totalOrder;
        //  if (totalOrder > 0) {
        // setIsButtonPressed(true); 
        //  } else {
        //   setIsButtonPressed(false); 
        //  }
          
          setFranchiseOrderRevenueData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    if (item) {
      setStoreData(item.storeId);
      setStoreStatus(item.status);
      setRevenueCalculateOnDate(new Date(item.revenueCalculateOn));
    }
  }, [item]);

  useEffect(() => {
    fetchAllBrands();
  }, []);

  const selectedTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const optionTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <div>{option.name}</div>
      </div>
    );
  };

  const [storeError, setStoreError] = useState("");

 let initialStartDate = new Date();
 initialStartDate.setFullYear(initialStartDate.getFullYear() - 1); // Go back 1 year
 initialStartDate.setMonth(initialStartDate.getMonth()); // (optional, keeps same month)
 initialStartDate.setDate(1); 
 
  const handleStoreChange = (selectedItem) => {
    setStoreData(selectedItem);

    const data = {
      storeIds: [selectedItem],
      brandId: brandId,
      statusIn: [
        "BOOKED",
        "INPROCESS",
        "IN_WAREHOUSE",
        "PROCESSED",
        "DELIVERED",
        "DONE",
        "OUT_FOR_DELIVERY",
        "DELAY_STATUS",
      ],
      startDate: localeDateStartDate(new Date(initialStartDate)),
      endDate: localeDateEndDate(new Date(new Date())),
    };

    fetchStoreOrderRevenue(data);
  };

  const StatusList = [
    {
      name: "ACTIVE",
      value: true,
    },
    {
      name: "INACTIVE",
      value: false,
    },
  ];

  const handleStatusChange = (selectedItem) => {
    setStoreStatus(selectedItem);
  };

  const handleSubmit = () => {
    // Reset all previous errors

    setStoreError("");
    setStatusError("");

    let isValid = true;
    if (item === null && !storeData) {
      setStoreError("Store Name is Required");
      isValid = false;
    }
    if (storeStatus === null) {
      setStatusError("Status is Required");
      isValid = false;
    }

    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        const data = {
          storeId: storeData,
          revenueCalculateOn: revenueCalculateOnDate,
        };

        const UpdateData = {
          id: item?.id,
          brandFranchise: {
            id: franchise.id,
          },
          storeId: storeData,
          status: storeStatus,
          revenueCalculateOn: revenueCalculateOnDate,
        };

        // Call the service function for creating pickup request

        if (item === null) {
          addFranchiseStoreMap(brandId, franchise.id, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.success;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/Franchise-Store-Mapped-List", {
                        state: {
                          item: franchise,
                        },
                      });
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          updateFranchiseStoreMap(brandId, franchise.id, UpdateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.success;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/Franchise-Store-Mapped-List", {
                        state: {
                          item: franchise,
                        },
                      });
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    } else {
      setIsButtonPressed(false);
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/Franchise-Store-Mapped-List", {
                      state: {
                        item: franchise,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Franchise Store Mapped {item?.id ? "Edit" : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      {item !== null && (
        <div className="flex flex-1 mb-3">
          <div className=" mt-2 mx-4 flex-1">
            <p className="text-xl text-black font-bold capitalize">
              Previously Selected Store : {storeMap}
            </p>
          </div>
        </div>
      )}
      {item === null && (
        <div className="flex flex-1 mb-3">
          <div className=" mt-4 mx-4 flex-1">
            <FloatLabel>
              <Dropdown
                id="store"
                value={storeData}
                onChange={(e) => handleStoreChange(e.target.value)}
                options={brandStoreList}
                optionLabel="name"
                placeholder="Store"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
                filter
                valueTemplate={selectedTemplate}
                itemTemplate={optionTemplate}
              />
              {storeError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {storeError}
                </p>
              )}
              <label
                htmlFor="store"
                className="text-md"
                style={{ color: "blue" }}
              >
                Store <span style={{ color: "red" }}>*</span>
              </label>
              {/*franchiseOrderRevenueData[0]?.totalOrder > 0 && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  This Store already has {franchiseOrderRevenueData[0]?.totalOrder} orders
                </p>
              )*/}
            </FloatLabel>
          </div>
        </div>
      )}

      <div className="flex-auto mt-1 mx-4">
        <p className="font-bold block mb-2 ml-2">Revenue Calculate On Date</p>
        <Calendar
          id="buttondisplay"
          value={revenueCalculateOnDate}
          onChange={(e) => handleRevenueCalculateOnDateChange(e.value)}
          showIcon
          minDate={minimumDate}
          maxDate={maximumDate}
          className="w-full  bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
          dateFormat="dd/mm/yy"
        />
      </div>
      {item !== null && (
        <div className="flex flex-1 mb-3">
          <div className=" mt-4 mx-4 flex-1">
            <FloatLabel>
              <Dropdown
                id="status"
                value={storeStatus}
                onChange={(e) => handleStatusChange(e.target.value)}
                options={StatusList}
                optionLabel="name"
                placeholder="status"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              {statusError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {statusError}
                </p>
              )}
              <label
                htmlFor="status"
                className="text-md"
                style={{ color: "blue" }}
              >
                Status <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
        </div>
      )}
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>
      {userRole === "BY_ACCOUNTANT" ? (
                    <FinanceAdminMenu setVisible={setVisible} visible={visible} />
                  ) : (
                    <AdminMenu setVisible={setVisible} visible={visible} />
                  )}
    </div>
  );
};

export default FranchiseStoreMap;
